import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { reportSchema } from "../../../validation/validationSchema";
import { reportLink } from "../../../redux/feedback/action";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

export default function ReportPageModal({ show, onHide, userId, url }) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(reportSchema),
    defaultValues: {
      pageUrl: url,
      feedback: "",
    },
  });

  const onSubmit = (data) => {
    if (!userId) {
      toast.error("Please login first to report link.");
      return;
    }
    dispatch(reportLink({ ...data, userId }));
    onHide();
    reset();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Report a Corrupted Link</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label htmlFor="pageUrl" className="form-label">
              URL
            </label>
            <input
              type="text"
              className="form-control"
              disabled
              {...register("pageUrl")}
            />
            {errors.pageUrl && (
              <p className="error-message">{errors.pageUrl.message}</p>
            )}
          </div>
          <div className="mb-3">
            <label htmlFor="feedback" className="form-label">
              Comment
            </label>
            <textarea
              {...register("feedback")}
              className="form-control"
              placeholder="Describe the issue…"
            />
            {errors.feedback && (
              <p className="error-message">{errors.feedback.message}</p>
            )}
          </div>
          <button className="btn btn-sm btn-solid-blue" type="submit">
            Submit Report
          </button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
